import { render, staticRenderFns } from "./DeleteInstruction.vue?vue&type=template&id=dbf32126&scoped=true&"
import script from "./DeleteInstruction.vue?vue&type=script&lang=js&"
export * from "./DeleteInstruction.vue?vue&type=script&lang=js&"
import style0 from "./DeleteInstruction.vue?vue&type=style&index=0&id=dbf32126&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf32126",
  null
  
)

export default component.exports